import React from 'react';
import DirectTestsGrid from './Specimen/DirectTestsGrid/DirectTestsGrid';
import ReportHistoryGrid from './Reports/ReportHistoryGrid/ReportHistoryGrid';
import FormDefinition from './Config/FormDefinition/FormDefinition';
import ReportDefinition from './Config/ReportDefinition/ReportDefinition';
import IqcResultsGrid from './Quality/IqcResultsGrid'
const CraftedRegionFactory = (props) => {

    let pageToDisplay = (null);
    switch(props.config.Name.toLowerCase()) {
        case "directtestsgrid":
            pageToDisplay = <DirectTestsGrid
                                config={props.config}
                                region={props.region}
                                containerVisibility={props.containerVisibility}
                                refresh={props.refresh}
                                passive={props.passive}
                                language={props.language}
                                onRefresh={props.onRefresh}
                                id={props.id}
                                stateid={props.stateid}
                            >
                            </DirectTestsGrid>
            break;
        case "reporthistorygrid":
            pageToDisplay = <ReportHistoryGrid
                                config={props.config}
                                id={props.id}
                                onRefresh={props.onRefresh}
                                language={props.language}
                                passive={props.passive}>
                            </ReportHistoryGrid>
            break;
        case "iqcresultsgrid":
            pageToDisplay = <IqcResultsGrid
                                config={props.config} 
                                data={props.data}
                                id={props.id}
                                refresh={props.refresh}
                                onRefresh={props.onRefresh}
                                containerVisibility={props.containerVisibility}
                                language={props.language}
                                onButtonClick={props.onButtonClick}
                                stateid={props.stateid}>
                            </IqcResultsGrid>
            break;
        case "pagesgrid":
            pageToDisplay = <FormDefinition 
                                config={props.config} 
                                data={props.data}
                                refresh={props.refresh}
                                onRefresh={props.onRefresh}
                                language={props.language}>
                            </FormDefinition>
            break;
        case "reportdefinition":
            pageToDisplay = <ReportDefinition 
                                config={props.config} 
                                data={props.data}
                                refresh={props.refresh}
                                onRefresh={props.onRefresh}
                                language={props.language}>
                            </ReportDefinition>
            break;
        default:
            pageToDisplay = <div>No crafted region found</div>
            break;
    }

    return (
        <React.Fragment>
            {pageToDisplay}
        </React.Fragment>
    );
};
  
export default CraftedRegionFactory;
